// John Eldhose 20180511
import { combineReducers } from 'redux';
import Languages from './Languages';
import LanguageSelected from './LanguageSelected';
import Academy from './Academy';
import LMDCache from './LMDCache';
import ShoppingCart from './ShoppingCart';
import UserSession from './UserSession';

const rootReducer = combineReducers({
  Academy,
  Languages,
  LanguageSelected,
  LMDCache,
  ShoppingCart,
  UserSession
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js